import type { Config } from './types';

export const config: Config = {
  env: 'staging',
  variant: {
    tvOSBundleId: 'com.creativelabs.fit52.staging.2',
    androidPackageName: {
      default: 'com.creativelabs.fit52tv.staging',
      play: 'com.creativelabs.fit52.staging',
    },
    name: 'HiNote Life TV Staging',
  },
  api: { baseURL: 'https://staging.fit52life.com/api' },
  pairingLink: { baseURL: 'https://go-staging.hinote.com' },
  downloadLink: { baseURL: 'https://go-staging.hinote.com' },
  unlockCode: 'fittv',
  shouldInitializeSentry: true,
  enableLogsStreamByDefault: true,
  sentry: {
    dsn: 'https://df0bfa4d896fe7f05b8d2f9af178c4ef@o249262.ingest.us.sentry.io/4511254168469504',
    project: 'fit52-tv-web-staging',
  },
};
